import { Messages, i18n } from '@lingui/core';
import { detect, fromNavigator } from '@lingui/detect-locale';

import { messages as messagesDe } from './de/messages.po';
import { messages as messagesEn } from './en/messages.po';

const SUPPORTED_LOCALES = ['de', 'en'];
const FALLBACK_LOCALE = 'en';

export default function initLocale(
  messages: {
    en: Messages;
    de: Messages;
  },
  overrideLocale?: string,
) {
  // use locales
  loadLocale(messages);

  const detectedLocale = overrideLocale ?? detect(fromNavigator()) ?? FALLBACK_LOCALE;
  // "de-DE" => "de"
  let activeLanguage = detectedLocale.split('-')[0];

  if (SUPPORTED_LOCALES.every((locale) => locale !== activeLanguage)) {
    activeLanguage = FALLBACK_LOCALE;
  }

  i18n.activate(activeLanguage);

  return {
    supported: SUPPORTED_LOCALES,
    active: activeLanguage,
  };
}

export function loadLocale(messages: { en: Messages; de: Messages }) {
  i18n.load('en', { ...messagesEn, ...messages.en });
  i18n.load('de', { ...messagesDe, ...messages.de });
}
